import { render, staticRenderFns } from "./ChoicesFormTemplate.vue?vue&type=template&id=1858de35&scoped=true"
import script from "./ChoicesFormTemplate.vue?vue&type=script&lang=js"
export * from "./ChoicesFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858de35",
  null
  
)

export default component.exports